import { StoreImageEnum, getCommonItem } from '@systemeio/digital-store-shared'
import { FormInput } from '@systemeio/ui'
import StoreFields from 'modules/stores/store/components/contact-fields'
import ItemSteps from 'modules/stores/store/components/item-steps'
import StoreImageSelector from 'modules/stores/store/components/store-image-selector'
import {
  OptinItemEditType,
  OptinItemErrorsType,
} from 'modules/stores/store/content/optin/types/optin-interface'
import { useStorePreviewContext } from 'modules/stores/store/context/store-preview-context'
import React, { Dispatch, FC, SetStateAction, useEffect } from 'react'
import FormTextarea from 'shared/components/form-textarea'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { optinInitFields } from '../constants/mandatory-fields'

interface OptinThumbnailProps {
  tempState: OptinItemEditType
  setTempState: Dispatch<SetStateAction<OptinItemEditType>>
  errors: OptinItemErrorsType
}

const OptinThumbnail: FC<OptinThumbnailProps> = ({ tempState, setTempState, errors }) => {
  const { t } = useLocoTranslation()

  const { setPreview, setSingleItemMode } = useStorePreviewContext()

  useEffect(() => {
    setPreview([getCommonItem(tempState)])
    setSingleItemMode(true)
  }, [setPreview, setSingleItemMode, tempState])

  return (
    <ItemSteps
      steps={[
        {
          key: 'image',
          title: t('dashboard.store.image.select_image'),
          element: (
            <StoreImageSelector
              dataFile={tempState.thumbnail}
              imageType={StoreImageEnum.optin_thumbnail}
              label={t('dashboard.store.image.thumbnail')}
              onChange={dataFile =>
                setTempState(prev => ({
                  ...prev,
                  thumbnail: dataFile,
                }))
              }
            />
          ),
        },
        {
          key: 'text',
          title: t('dashboard.store.item.add_text'),
          element: (
            <div className={'flex flex-col gap-5'}>
              <div className={'grid grid-cols-1 gap-5 sm:grid-cols-2'}>
                <FormInput
                  required
                  value={tempState.title}
                  label={t('dashboard.store.item.title')}
                  onChange={({ target: { value } }) =>
                    setTempState(prev => ({ ...prev, title: value }))
                  }
                  error={errors.title}
                />
                <FormInput
                  required
                  value={tempState.buttonTitle}
                  label={t('dashboard.store.item.button')}
                  onChange={({ target: { value } }) =>
                    setTempState(prev => ({ ...prev, buttonTitle: value }))
                  }
                  error={errors.buttonTitle}
                />
              </div>
              <FormTextarea
                required
                value={tempState.subTitle}
                label={t('dashboard.store.item.subtitle')}
                onChange={({ target: { value } }) =>
                  setTempState(prev => ({ ...prev, subTitle: value }))
                }
                error={errors.subTitle}
              />
            </div>
          ),
        },
        {
          key: 'url',
          title: t('dashboard.store.item.collect_info'),
          element: (
            <StoreFields
              fields={tempState.fields}
              onChange={fields => setTempState(prev => ({ ...prev, fields }))}
              initFields={optinInitFields}
            />
          ),
        },
      ]}
    />
  )
}

export default OptinThumbnail
